// extracted by mini-css-extract-plugin
export default {"container":"_q-z","ratingLayout":"ar-z","ratingLabel":"br-z"};